<template>
  <div v-if="!isPrintOrder">
    <page-header title="Калькулятор доставки груза" title-in-breadcrumbs="Калькулятор стоимости"/>
    <div class="public-order-wrapper">
      <div class="public-container public-order">
        <vz-order hide-title />
      </div>
    </div>
    <vz-order-seo-footer />
  </div>
  <vz-print-order v-else />
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import VzPrintOrder from '@/pages/personal/order/print.vue'
import {setPageLayout} from '#app/composables/router';
import VzOrder from '~/components/personal/order/vz-order.vue';
import VzOrderSeoFooter from '~/components/personal/order/vz-order-seo-footer.vue';

definePageMeta({
  middleware: defineNuxtRouteMiddleware((to, from) => {
    if (to.query.hasOwnProperty('printOrder')) {
      setPageLayout('empty')
    }
  })
})

const isPrintOrder = computed(() => {
  return !!useRoute().query?.hasOwnProperty('printOrder')
})
</script>
